import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { trackFetchErrors } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { PACKAGE_NAME } from './privacyLevelPrivate.constants.tsx';
import type { SettingsGet } from './SettingsGet.types.tsx';

export const getAnnouncementBannerSettings = async (): Promise<SettingsGet> => {
	try {
		return await performGetRequest('/rest/internal/3/announcement-banner');
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// 403 - banner is set to private and user is anonymous
		if (error.statusCode === 403) {
			return {
				message: '',
				isEnabled: false,
				isDismissable: false,
				visibility: 'private',
				hashId: '',
			};
		}

		trackFetchErrors({
			error,
			id: 'settingsGet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};
